import React from 'react';
import { Alert, Col, Form, Row } from 'react-bootstrap';
import { ActionButtons, Loader } from '../../../common/components';
import { LOADING_STATUS, WEEKDAYS_SHORT } from '../../../common/constants';
import {
  WeekdayCheckInRuleItem,
  WeekdayCheckOutRuleItem,
} from '../../../common/types/rates.types';

function WeekdayCheckInCheckOutRestrictionsForm({
  checkInLoadingStatus,
  checkOutLoadingStatus,
  handleCheckInInputChange,
  handleCheckOutInputChange,
  handleCopyableWeekdayCheckInChange,
  handleCopyableWeekdayCheckOutChange,
  handleActiveWeekdayCheckInChange,
  handleActiveWeekdayCheckOutChange,
  onSubmit,
  submitted,
  weekdayCheckInRules,
  weekdayCheckOutRules,
  hasWriteAccess,
  isDefaultRate = false,
}: {
  checkInLoadingStatus: LOADING_STATUS;
  checkOutLoadingStatus: LOADING_STATUS;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleCheckInInputChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleCheckOutInputChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleCopyableWeekdayCheckInChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleCopyableWeekdayCheckOutChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleActiveWeekdayCheckInChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleActiveWeekdayCheckOutChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  onSubmit: any;
  submitted: boolean;
  weekdayCheckInRules: WeekdayCheckInRuleItem[];
  weekdayCheckOutRules: WeekdayCheckOutRuleItem[];
  hasWriteAccess: boolean;
  isDefaultRate?: boolean;
}) {
  const renderWeekdayCheckInRuleItems = (
    <>
      <h4 className="h5 mb-24">
        Mahdolliset viikonpäivät sisäänkirjautumiselle
      </h4>
      <Row xs="auto" className="mb-24">
        {WEEKDAYS_SHORT.map(weekdayItem => (
          <Col key={`checkInRule-${weekdayItem.weekdayInt}`}>
            <Form.Group
              controlId={`checkInRule-${weekdayItem.weekdayInt}`}
              className="mb-24"
            >
              <Form.Label>
                <strong>{weekdayItem.weekdayString}</strong>
              </Form.Label>
              <Form.Check
                type="checkbox"
                name={`checkInRule-${weekdayItem.weekdayInt}`}
                onChange={e =>
                  handleCheckInInputChange(e, weekdayItem.weekdayInt)
                }
                checked={
                  weekdayCheckInRules.filter(
                    rule => rule.weekday === weekdayItem.weekdayInt,
                  ).length === 0
                }
                disabled={!hasWriteAccess}
              />
            </Form.Group>
          </Col>
        ))}
      </Row>
    </>
  );

  const renderWeekdayCheckOutRuleItems = (
    <>
      <h4 className="h5 mb-24">Mahdolliset viikonpäivät uloskirjautumiselle</h4>
      <Row xs="auto" className="mb-24">
        {WEEKDAYS_SHORT.map(weekdayItem => (
          <Col key={`checkOutRule-${weekdayItem.weekdayInt}`}>
            <Form.Group
              controlId={`checkInRule-${weekdayItem.weekdayInt}`}
              className="mb-24"
            >
              <Form.Label>
                <strong>{weekdayItem.weekdayString}</strong>
              </Form.Label>
              <Form.Check
                type="checkbox"
                name={`checkInRule-${weekdayItem.weekdayInt}`}
                onChange={e =>
                  handleCheckOutInputChange(e, weekdayItem.weekdayInt)
                }
                checked={
                  weekdayCheckOutRules.filter(
                    rule => rule.weekday === weekdayItem.weekdayInt,
                  ).length === 0
                }
                disabled={!hasWriteAccess}
              />
            </Form.Group>
          </Col>
        ))}
      </Row>
    </>
  );

  return (
    <>
      <Loader
        IsLoading={
          checkInLoadingStatus === LOADING_STATUS.LOADING ||
          checkOutLoadingStatus === LOADING_STATUS.LOADING
        }
      />
      {checkInLoadingStatus === LOADING_STATUS.IDLE &&
        checkOutLoadingStatus === LOADING_STATUS.IDLE && (
          <>
            {renderWeekdayCheckInRuleItems}

            {isDefaultRate ? (
              <>
                <input type="hidden" name="isActiveCheckInRules" value="true" />
                <input
                  type="hidden"
                  name="isCopyableCheckInRules"
                  value="true"
                />
              </>
            ) : (
              <Row xs={1} md={2}>
                <Col>
                  <Form.Group
                    controlId="isActiveCheckInRules"
                    className="mb-24"
                  >
                    <Form.Label>Sisäänkirjautumissäännöt aktiiviset</Form.Label>
                    <Form.Check
                      type="checkbox"
                      name="isActiveCheckInRules"
                      onChange={e => handleActiveWeekdayCheckInChange(e)}
                      checked={
                        weekdayCheckInRules.filter(rule => !rule.isActive)
                          .length === 0
                      }
                      disabled={!hasWriteAccess}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group
                    controlId="isCopyableCheckInRules"
                    className="mb-24"
                  >
                    <Form.Label>
                      Sisäänkirjautumissäännöt kopioitavia
                    </Form.Label>
                    <Form.Check
                      type="checkbox"
                      name="isCopyableCheckInRules"
                      onChange={e => handleCopyableWeekdayCheckInChange(e)}
                      checked={
                        weekdayCheckInRules.filter(rule => !rule.isCopyable)
                          .length === 0
                      }
                      disabled={!hasWriteAccess}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            <hr className="hr-light mb-32" />

            {renderWeekdayCheckOutRuleItems}

            {isDefaultRate ? (
              <>
                <input
                  type="hidden"
                  name="isActiveCheckOutRules"
                  value="true"
                />
                <input
                  type="hidden"
                  name="isCopyableCheckOutRules"
                  value="true"
                />
              </>
            ) : (
              <Row xs={1} md={2}>
                <Col>
                  <Form.Group
                    controlId="isActiveCheckOutRules"
                    className="mb-24"
                  >
                    <Form.Label>Uloskirjautumissäännöt aktiiviset</Form.Label>
                    <Form.Check
                      type="checkbox"
                      name="isActiveCheckOutRules"
                      onChange={e => handleActiveWeekdayCheckOutChange(e)}
                      checked={
                        weekdayCheckOutRules.filter(rule => !rule.isActive)
                          .length === 0
                      }
                      disabled={!hasWriteAccess}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group
                    controlId="isCopyableCheckOutRules"
                    className="mb-24"
                  >
                    <Form.Label>Uloskirjautumissäännöt kopioitavia</Form.Label>
                    <Form.Check
                      type="checkbox"
                      name="isCopyableCheckOutRules"
                      onChange={e => handleCopyableWeekdayCheckOutChange(e)}
                      checked={
                        weekdayCheckOutRules.filter(rule => !rule.isCopyable)
                          .length === 0
                      }
                      disabled={!hasWriteAccess}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            <ActionButtons
              HandleSave={onSubmit}
              HideSaveButton={!hasWriteAccess}
              HideCancelButton
              DeleteButtonText=""
            />

            {submitted && (
              <div className="mt-2 pt-2">
                <Alert variant="success">Tiedot tallennettu!</Alert>
              </div>
            )}
          </>
        )}
    </>
  );
}

export default WeekdayCheckInCheckOutRestrictionsForm;
